import PropTypes from "prop-types";
import { Typography } from "@mui/material";

function Title({ variant, component, sx, color, children }) {
  return (
    <Typography sx={sx} component={component || "h2"} variant={variant || "h6"} color={color || "primary"} gutterBottom>
      {children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  component: PropTypes.string,
  sx: PropTypes.object,
  color: PropTypes.string,
};

export default Title;
